import { isMac } from 'src/app/graph/explorerPage/helpers/isMac';

// this file has no effect on monaco hotkeys, and is only used for displaying
// hotkeys within the ui (ie keyboard shortcut modal)

export interface MonacoHotkeyDictionaryItem {
  actionName: string;
  label: string;
}

export const formatDocument: MonacoHotkeyDictionaryItem = {
  actionName: 'Format Document',
  label: `Shift + ${isMac ? 'Option' : 'alt'} + F`,
};

export const goToDefinition: MonacoHotkeyDictionaryItem = {
  actionName: 'Go to Definition',
  label: `${isMac ? '⌘' : 'Ctrl'} + F12`,
};

export const suggestFields: MonacoHotkeyDictionaryItem = {
  actionName: 'Suggest Fields',
  label: `${isMac ? 'Control' : 'Ctrl'} + Spacebar`,
};
